import { ContractType, type ContractBalance } from 'src/graphql/generated';
import type { HirerType } from 'src/types';

export const getHirerTypeFromContracts = (
  advertiserContracts?: ContractBalance[],
): HirerType => {
  const isVariablePriceContract = (contract: ContractBalance) =>
    contract.contractType === ContractType.SEEK_CONTRACT;

  const isFixedPriceContract = (contract: ContractBalance) =>
    contract.contractType === ContractType.AD_PACK ||
    contract.contractType === ContractType.MASTER_AGREEMENT ||
    contract.contractType === ContractType.SUBSCRIPTION;

  if (!advertiserContracts) {
    return 'casual';
  }

  if (advertiserContracts.some(isVariablePriceContract)) {
    return 'contract';
  } else if (advertiserContracts.some(isFixedPriceContract)) {
    return 'ad-pack';
  }

  return 'casual';
};
